import imageCompression from 'browser-image-compression';

/**
 * Compresses and resizes an image file based on the specified type.
 * @param {File} file - The original image file.
 * @param {string} type - The type of image ('vehicle', 'event', 'trackmap').
 * @returns {Promise<File>} - The compressed image file.
 */
export const compressImage = async (file, type) => {
  try {
    let maxWidthOrHeight;
    switch (type) {
      case 'vehicle':
        maxWidthOrHeight = 800;
        break;
      case 'event':
      case 'trackmap':
        maxWidthOrHeight = 1600;
        break;
      default:
        maxWidthOrHeight = 1600; // Default fallback
    }

    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight,
      useWebWorker: true,
      quality: 0.7, // 70%
    };

    const compressedFile = await imageCompression(file, options);
    return compressedFile;
  } catch (error) {
    console.error('Image compression failed:', error);
    throw new Error('Failed to compress image. Please try again.');
  }
};